// extracted by mini-css-extract-plugin
export var externalLink = "_9k-0";
export var internalLinkLabel = "_9k-1";